<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/miscs`;
const token = utilsService.getToken();

const miscService = {
  async getPaisesOptions() {
    try {
      const response = await axios.get(`${apiUrl}/paises/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getUomsOptions() {
    try {
      const response = await axios.get(`${apiUrl}/uoms/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getConformidadesOptions() {
    try {
      const response = await axios.get(`${apiUrl}/conformidades/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getMonedasOptions() {
    try {
      const response = await axios.get(`${apiUrl}/monedas/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getRolesOptions() {
    try {
      const response = await axios.get(`${apiUrl}/roles/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getEmpresasByPaisOptions(pais) {
    try {
      const response = await axios.get(`${apiUrl}/${pais}/empresas/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getEmpresasOptions() {
    try {
      const response = await axios.get(`${apiUrl}/empresas/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getMaterialesOptions() {
    try {
      const response = await axios.get(`${apiUrl}/materiales/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getChoferesOptions() {
    try {
      const response = await axios.get(`${apiUrl}/choferes/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getEstadosOptions() {
    try {
      const response = await axios.get(`${apiUrl}/estados/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getEstadoPagosOptions() {
    try {
      const response = await axios.get(`${apiUrl}/pagos/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getPasillosByEmpresaOptions(empresa, planta) {
    try {
      const response = await axios.get(`${apiUrl}/${empresa}/${planta}/pasillos/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },  

  async getPasillosByPlantaOptions(planta) {
    try {
      const response = await axios.get(`${apiUrl}/${planta}/pasillos/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },  

  async getPlantasByEmpresaOptions(empresa) {
    try {
      const response = await axios.get(`${apiUrl}/${empresa}/plantas/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getPlantasByOptions() {
    try {
      const response = await axios.get(`${apiUrl}/plantas/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getAllOptions() {
    try {
      const response = await axios.get(`${apiUrl}/all/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getCiudadesOptions(region) {
    try {
      const response = await axios.get(`${apiUrl}/${region}/ciudades/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getRegionesOptions(pais) {
    try {
      const response = await axios.get(`${apiUrl}/${pais}/regiones/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
  async getComunasOptions(region) {
    try {
      const response = await axios.get(`${apiUrl}/${region}/comunas/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getTipoAdjuntoOptions() {
    try {
      const response = await axios.get(`${apiUrl}/tipo-adjunto/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getIndustriaOptions() {
    try {
      const response = await axios.get(`${apiUrl}/industrias/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getSectorOptions() {
    try {
      const response = await axios.get(`${apiUrl}/sectores/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  }, 
  async getIngresosOptions() {
    try {
      const response = await axios.get(`${apiUrl}/ingresos/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
};

export default miscService;
</script>
